import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DynamicDialogRef, DialogService, TreeNode, MenuItem, DynamicDialogConfig, MessageService } from 'primeng/api';
import { IPaginatedTable } from 'src/app/Interfaces/IPaginatedTable'
import { PaginatedTable } from 'src/app/Components/PaginatedTable/PaginatedTable'
import 'rxjs/add/operator/debounceTime';
import { environment } from 'src/environments/environment';
import { state, trigger, style, transition, animate } from '@angular/animations';
import { Indicator } from 'src/app/Models/Indicator'
import { Factor } from 'src/app/Models/Factors/Factor';
import { DateFormatPipe } from 'src/app/Pipes/DateFormatPipe';
import { Region } from 'src/app/Models/Handbooks/Region';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';
import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';

@Component({
    selector: 'app-indicators-factors-list',
    templateUrl: './FactorsList.html',
    styleUrls: ['./style.less'],
    providers: [DialogService, MessageService, DateFormatPipe, CurrentLangPipe, TranslatePipe],
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class FactorsListComponent extends PaginatedTable<Factor> implements OnInit, IPaginatedTable<Factor> {

    updating: boolean = false;

    getData() {
        this.isLoading = true;
        return this.http.get(`${environment.apiUrl}/api/Factors/Paged/${this.config.data.Indicator.Id}?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&filter=${this.filters}&sort=${this.sorts}`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    afterPaginate() {
        this.setData(() => {
            this.isLoading = false;
        });
    }

    getRegions() {
        return this.http.get(`${environment.apiUrl}/api/Regions/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    Regions: Array<Region> = [];
    get RegionsOptions(): Array<any> {
        var _s = this.Regions.map((x: Region) => ({
            label: (this.CurrentLang == 'ru') ? x.NameRu : ((this.CurrentLang == 'kk') ? x.NameKz : x.NameEn),
            value: x.Id,
            disabled: false
        }));
        _s.unshift({label: '', value: 0, disabled: true });
        return _s;
    }
    ObtainRegionsNames(fact: Factor): string {
        return fact.RegionsIds.map(x => {
            var s = this.Regions.filter(z => z.Id == x)[0]
            return (this.CurrentLang == 'ru') ? s.NameRu : ((this.CurrentLang == 'kk') ? s.NameKz : s.NameEn)
        }).join(' ')
    }

    Current: Factor = null;
    Periodicity: Periodicity = null;
    ToCreation: Factor = new Factor();

    onRowEditInit(factor: Factor) {
        this.list.map(x => x.isEditable = false)
        factor.isEditable = true;
        this.Current = new Factor();
        this.Current.Id = "" + factor.Id;
        this.Current.Value = factor.Value + 0;
        this.Current.PlannedValue = this.Indicator.IsPlannedAvailable
            ? factor.PlannedValue + 0
            : 0;
        this.Current.Comment = "" + factor.Comment;
        this.Current.RegionId = 0 + factor.RegionId;
        this.Current.PeriodStart = new Date(factor.PeriodStart);
        this.Current.PeriodEnd =   new Date(factor.PeriodEnd);
    }
    onRowEditSave(factor: Factor) {
        this.updating = true;
        this.http.put(`${environment.apiUrl}/api/Factors/Update`, JSON.stringify({
            Id: this.Current.Id,
            Comment: this.Current.Comment,
            PlannedValue: this.Indicator.IsPlannedAvailable
                ? this.Current.PlannedValue
                : 0,
            Value: this.Current.Value,
            RegionId: this.Current.RegionId,
            PeriodStart: this.Current.PeriodStart.toLocaleString(),
            PeriodEnd: this.Current.PeriodEnd.toLocaleString()
        }), { headers: { "Content-Type": "application/json" } }).subscribe(
            (data: Indicator) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.factorHasBeenUpdated')
                });
                this.updating = false;
                this.filtersChanged();
            },
            err => {
                this.updating = false;
            },
            () => {
                this.updating = false;
            }
        )
    }
    onRowEditCancel() {
        this.list.map(x => x.isEditable = false)
        this.Current = new Factor();
    }
    createNewFactor() {
        this.ToCreation;
        this.updating = true;
        this.http.post(`${environment.apiUrl}/api/Factors/Create`, JSON.stringify({
            IndicatorId: this.Indicator.Id,
            Comment: this.ToCreation.Comment,
            PlannedValue: this.Indicator.IsPlannedAvailable
                ? this.ToCreation.PlannedValue
                : 0,
            Value: this.ToCreation.Value,
            RegionId: this.ToCreation.RegionId,
            PeriodStart: this.ToCreation.PeriodStart.toLocaleString()
        }), { headers: { "Content-Type": "application/json" } }).subscribe(
            (data: Indicator) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.factorHasBeenCreated')
                });
                this.updating = false;
                this.filtersChanged();
            },
            err => {
                this.updating = false;
            },
            () => {
                this.updating = false;
            }
        )
    }

    Indicator: Indicator = null;

    constructor(
        private http: HttpClient,
        public ref: DynamicDialogRef,
        public dialogService: DialogService,
        public config: DynamicDialogConfig,
        private messageService: MessageService,
        private _dateFormatPipe: DateFormatPipe,
        private currentLangPipe: CurrentLangPipe,
        private translatePipe: TranslatePipe,
        // private cookieService: CookieService
    ) {
        super();
        
        this.Indicator = config.data.Indicator;
    }

    CurrentLang: string = 'ru';

    ngOnInit() {
        this.Periodicity = this.config.data.Indicator.Periodicity;
        this.Indicator = this.config.data.Indicator;
        this.CurrentLang = this.currentLangPipe.get();
        this.getRegions().subscribe((data: Array<Region>) => {
            this.Regions = data;
            this.setData();
        })
    }

    filtersChanged() { this.setData(() => { this.isLoading = false; }) }

}